import React, { useEffect, useState } from "react";
import Spinner from "../../components/_common/Spinner";

export interface InputProps {
  data: any,
  isloading: Boolean;
}

const Financial = ({  data, isloading}: InputProps) => {
 
  return (
    <div className="tab-content-padding">

      {isloading === false && (
        <>
        <div className="row">
            <div className="col-md-3">
                درآمد:
            </div>
            <div className="col-md-3">
                <p>{data[0].Income} تومان</p>
            </div>
            <div className="col-md-3">
                 تخفیف:
            </div>
            <div className="col-md-3 ">
                 <p>{data[0].Discount} تومان</p>
            </div>
        </div>
         <div className="row">
         <div className="col-md-3">
               دریافتی:
         </div>
         <div className="col-md-3 ">
             <p>{data[0].Cash} تومان</p>
         </div>
         <div className="col-md-3">
             کسری:
         </div>
         <div className="col-md-3 ">
              <p>{data[0].Deficit} تومان</p>
         </div>
        </div>
         <div className="row">
      <div className="col-md-3">
           تعداد صندوق:
      </div>
      <div className="col-md-3 ">
          <p>{data[0].CountOfCashier}</p>
      </div>
      
        </div>
  </>
      )}

      {isloading === true && (
        <Spinner />
      )}

    </div>
  )

};

export default Financial;
